/* ------------------------------------------------------------ *\
    This is an automatically generated file - do not edit.
\* ------------------------------------------------------------ */
import 'popper.js';
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';
